import React, { useState } from 'react'
import { login } from '../services/auth'
import './Login.css'

function Login({ returnUrl = '/dashboard' }) {
  const [error, setError] = useState(null)

  const handleLogin = () => {
    try {
      setError(null)
      login(returnUrl)
    } catch (err) {
      setError(err.message || 'Login failed. Please try again.')
      console.error('Login error:', err)
    }
  }

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-logo">
          <img src="/logo.png" alt="Ditto Logo" />
        </div>
        <h2>Sign in to Ditto</h2>
        <p className="login-message">
          Sign in with your Microsoft account to access the Ditto Training System
        </p>

        {error && (
          <div className="login-error">
            {error}
          </div>
        )}

        <button
          className="login-button"
          onClick={handleLogin}
        >
          <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="1" y="1" width="9" height="9" fill="#F25022"/>
            <rect x="11" y="1" width="9" height="9" fill="#7FBA00"/>
            <rect x="1" y="11" width="9" height="9" fill="#00A4EF"/>
            <rect x="11" y="11" width="9" height="9" fill="#FFB900"/>
          </svg>
          Sign in with Microsoft
        </button>

        <p className="login-hint">
          You'll be redirected to Microsoft to sign in securely
        </p>
      </div>
    </div>
  )
}

export default Login
